import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import "../Css/Timeline.css";
import { FaPencil } from "react-icons/fa6";
import Navbar from './Navbar';
import { Typography, CircularProgress } from '@mui/material';
import { FaListUl } from "react-icons/fa";

function Timeline() {
    const { orderId } = useParams();
    const [orders, setOrders] = useState([]);
    const [changes, setChanges] = useState([]);
    const [loading, setLoading] = useState(true); // New loading state
    const [error, setError] = useState(null); // Error state for handling changes being null
    const adminEmail = sessionStorage.getItem('userEmail');

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const response = await fetch(`/api/ordera/p/${orderId}/${adminEmail}`);
                if (response.ok) {
                    const data = await response.json();
                    setOrders(data);
                    if (data.history && Array.isArray(data.history)) {
                        const sortedHistory = data.history.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
                        setChanges(sortedHistory);
                    } else {
                        setChanges([]);
                        setError('No history data available');
                    }
                } else {
                    setError('Failed to fetch orders data');
                }
            } catch (error) {
                setError('Error fetching orders: ' + error.message);
            } finally {
                setLoading(false); // Stop loading after data fetch
            }
        };

        fetchOrders();
    }, [orderId, adminEmail]);

    const formatTime = (dateString) => {
        const date = new Date(dateString);
        const formattedTime = date.toLocaleTimeString();
        return formattedTime;
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const formattedDate = date.toLocaleDateString();
        return formattedDate;
    };

    return (
        <div className='timeline'>
            <Navbar />
            <p className='history-text'>Order History</p>
            <div className='t-box'>
                {loading ? ( // Display loading message while data is fetching
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '50vh' }}>
                        <CircularProgress />
                        <Typography variant="h6" style={{ marginTop: '20px' }}>Fetching history...</Typography>
                    </div>
                ) : error ? ( // Display error message if there's an error
                    <div className="error-message">{error}</div>
                ) : changes && changes.length > 0 ? ( // Display the changes if available
                    <ul>
                        {changes.map((history, index) => (
                            <li key={index} className='list-item'>
                                <div className='pa-box'>
                                    <p className='paragraph'>{formatDate(history.timestamp)}</p>
                                    <p className='paragraph'>{formatTime(history.timestamp)}</p>
                                </div>
                                <div className='history'>
                                    <div className='a-box'>
                                        <div className='arrow'>
                                            <FaPencil />
                                        </div>
                                        <div className="vertical-line"></div>
                                    </div>
                                    <div className='conte'>
                                        {/* Conditional message based on the action */}
                                        {["Made pickup ready", "Made not pickup ready", "Marked as Pick Up", "Marked as On the Way"].includes(history.action) ? (
                                            <>{orders.Order_No} was {history.action} by {history.driver}</>
                                        ) : ["Assigned", "Reassigned", "Assigned for Payment collection"].includes(history.action) ? (
                                            <>
                                                {orders.Order_No} was {history.action} to {history.driver} by {history.admin}
                                                {history.reason && <> (Reason: {history.reason})</>}  {/* Show reason if present */}
                                            </>
                                        ) : ["completed"].includes(history.action) ? (
                                            <>
                                                {orders.Order_No} was {history.action} by {history.driver} with mop: {orders.mop}
                                                {orders.mop2 ? ` and mop2: ${orders.mop2} ` : ""}
                                                {orders.mop3 ? ` and mop3: ${orders.mop3}` : ""}
                                                {orders.amount1 && orders.amount2 && orders.amount3
                                                    ? ` with respective amounts: ${orders.amount1}, ${orders.amount2}, and ${orders.amount3}`
                                                    : orders.amount1 && orders.amount2
                                                        ? `with respective amounts: ${orders.amount1} and ${orders.amount2}`
                                                        : orders.amount1
                                                            ? ` with amount: ${orders.amount1}`
                                                            : ""}
                                            </>
                                        ) : (
                                            <>
                                                {orders.Order_No} was {history.action} by {history.driver}
                                                {history.reason && <> (Reason: {history.reason})</>}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <tr className="lesser-full-width-container" style={{ height: '65vh' }}>
                        <td className="noOrders" colSpan="9">
                            <div className="center-content">
                                <div className="icon-wrapper">
                                    <FaListUl className="icon" />
                                </div>
                                <span className="noOrdersMsg">No history available</span>
                            </div>
                        </td>
                    </tr>
                )}
            </div>
        </div>
    );
}

export default Timeline;
